<template>
  <svg width="15" height="17" viewBox="0 0 15 17" xmlns="http://www.w3.org/2000/svg">
    <g fill-rule="nonzero" fill="#000">
      <path d="M0 4.167c0-.46.373-.833.834-.833h13.332a.834.834 0 0 1 0 1.666H.834A.833.833 0 0 1 0 4.167zM2.35 5.847a.833.833 0 0 1 .97.67l1.418 7.798a.833.833 0 0 0 .82.685h3.884a.833.833 0 0 0 .82-.684l1.419-7.798a.833.833 0 1 1 1.639.298l-1.418 7.798a2.5 2.5 0 0 1-2.46 2.053H5.558a2.5 2.5 0 0 1-2.46-2.053L1.68 6.816a.833.833 0 0 1 .67-.97z" />
      <path d="M4.166 2.5a2.5 2.5 0 0 1 2.5-2.5h1.668a2.5 2.5 0 0 1 2.5 2.5v1.667c0 .46-.374.833-.834.833H5a.833.833 0 0 1-.834-.833V2.5zm2.5-.833a.833.833 0 0 0-.832.833v.834h3.332V2.5a.833.833 0 0 0-.832-.833H6.666z" />
    </g>
  </svg>
</template>

<script lang="ts">
import { defineComponent } from 'vue'

export default defineComponent({
  name: 'GoRateDeleteOutline'
})
</script>
